import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType } from 't4core';
import * as uuid from 'uuid';
import { T4File } from '../../../../projects/t4core/src/public-api';

@Component({
    selector: 'uploadImagesDialog',
    templateUrl: 'uploadImagesDialog.html',
    styleUrls: ['./uploadImagesDialog.css']
})
export class UploadImagesDialog extends DialogBase {
    public txtKeywords: FormControl = new FormControl();
    public images: T4Image[] = [];
    public files: any[] = [];
    public myId: any;
    public maxImages = 5;
    public maxFiles = 10;
    public imageType = 4;
    public fileType;
    public loading = false;
    public title = "";

    @ViewChild("txtFile") private txtFile: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<UploadImagesDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("UploadImagesDialog");

    }

    public async ngOnInit() {
        this.loading = true;
        if (this.data.maxFiles) this.maxFiles = this.data.maxFiles;
        if (this.data.fileType) this.fileType = this.data.fileType;
        if (this.fileType == 'img') {
            this.title = this.translate('Turbo.Service.CreateServiceRequestDialog.AddImages', 'Add images');
        }
        else {
            this.title = this.translate('Turbo.Service.CreateServiceRequestDialog.AddFiles', 'Add files');
        }
        this.loading = false;
    }

    public beginUpload() {
        this.txtFile.nativeElement.click();
    }

    public async removeFile(file: T4File, index: number) {
        this.loading = true;
        await this.Api.post<any[]>("Service/RemoveFile", null, { requestId: this.data.requestId, filename: file.Filename });
        this.data.files.splice(index, 1);
        this.loading = false;
    }

    public async uploadFiles(files: FileList) {
        let me = this;

        //Do not exceed maximum files
        if ((files.length + this.files.length) > this.maxFiles) {
            alert('Each case can contain a maximum of ' + this.maxFiles + 'files');
            return;
        }

        var guid = uuid.v4();
        console.log(files);


        for (var i = 0; i < files.length; i++) {
            var currentFile = files[i];
            console.log(files[i]);
            let reader = new FileReader();
            reader.readAsDataURL(currentFile);
            reader.onload = async function () {

                me.loading = true;
                console.log(currentFile);
                //Check for duplicate names
                let name = currentFile.name;
                if (me.data.files.find(x => x.Filename == me.fileType + '_' + currentFile.name)) {

                    var number = 1;
                    while (me.data.files.find(x => x.Filename == (me.fileType + '_' + "" + number + "-Copy_" + currentFile.name))) {
                      number++;
                    }
                    name = "" + number + "-Copy_" + currentFile.name;
                }

                await me.Api.post<any>("Service/UploadFileFromT4", "\"" + reader.result.toString() + "\"", { requestId: me.data.requestId, filename: me.fileType + '_' + name, mimeType: currentFile.type });
                me.data.files = await me.Api.get<any[]>("Service/GetFiles", { requestId: me.data.requestId });
                console.log(me.data.files);
                me.loading = false;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
        this.txtFile.nativeElement.value = '';
    }

    public save() {
        this.dialogRef.close(this.data);
    }
}
